import { useEffect } from 'react';
import {
    withRouter
} from 'react-router-dom';
import {
    Button,
    Thumbnail,
    Text,
    Badge,
    IndexTable,
    useIndexResourceState,
    Tooltip,

} from '@shopify/polaris';
import { NoteIcon } from "@shopify/polaris-icons";
import '../index.scss';
import Language from '../../../../../i18n/Language';
const t = Language;

const IndexTableImage = (props) => {
    // 通信数据
    const {
        id,
        tabKey,
        loading,
        isShowAutoState,
        dataList,
        obj_name,
        headings,
        getTableItemState,
        promotedBulkActions,
        tableType,
        jumpOptImgDetails,
        openDetailCompareModal,
        DownloadImage,
        RestoreImageData,
        isShowProgress,
        handleOptimize,
        optSingleRestoreImage,
        restoreProId,


    } = props;

    // 源文案
    const resourceName = {
        singular: `dataList`,
        plural: `${t(obj_name)}`,
    };

    const selectableOrders = dataList.filter((item) => !item.disabled);
    const { selectedResources, allResourcesSelected, handleSelectionChange, clearSelection } = useIndexResourceState(selectableOrders);

    // 阻止冒泡
    const stopActionDeep = (e) => {
        e.stopPropagation();
    }

    // 比特转换
    const changeBitInfo = (limit) => {
        let size = "";
        if (limit < 1 * 1024 * 1024) {
            //小于0.1MB，则转化成KB 
            size = (limit / 1024).toFixed(2) + "KB"
        } else if (limit < 1 * 1024 * 1024 * 1024) {
            //小于0.1GB，则转化成MB 
            size = (limit / (1024 * 1024)).toFixed(2) + "MB"
        } else {
            //其他转化成GB 
            size = (limit / (1024 * 1024 * 1024)).toFixed(2) + "GB"
        }
        return size;
    }

    // 处理产品列表行点击
    const handleProRowClick = (item, key) => {
        jumpOptImgDetails(item);
    }

    // 展示图片
    const handleViewImage = (item) => {
        openDetailCompareModal(item);
    }

    // 没有图片
    const noteImg = <Thumbnail
        source={NoteIcon}
        size="small"
        alt=""
    />

    // 列表内容
    const TableDataList = dataList.map((item, index) => {
        return tableType === 'manually' ? <IndexTable.Row
            id={item.id}
            key={item.id}
            selected={selectedResources.includes(item.id)}
            position={index}
            disabled={loading}
        >
            <IndexTable.Cell>
                {
                    tabKey === 0 ? (Boolean(item?.image) && typeof item.image === 'string' ?
                        <Thumbnail
                            source={JSON.parse(item.image)['src'] || ''}
                            size="small"
                            alt={JSON.parse(item.image)['alt']}
                        /> : noteImg) : ([1, 2].includes(tabKey) && Boolean(item.image) ? <Thumbnail
                            source={item.image.src || ''}
                            size="small"
                            alt={item.image.src}
                        /> : noteImg)
                }
            </IndexTable.Cell>
            <IndexTable.Cell>
                <div className='limit_title'>
                    {item.title}
                </div>
            </IndexTable.Cell>
            {
                tabKey === 0 && <IndexTable.Cell>{item.images_count}</IndexTable.Cell>
            }
            <IndexTable.Cell>
                {
                    (tabKey === 0 && Boolean(item.status)) ? <Badge>{t(item.status)}</Badge> :
                        ((tabKey === 1 || tabKey === 2) && Boolean(item.published_at) ? <Badge>{t("active")}</Badge> : <Badge>{t("draft")}</Badge>)
                }
            </IndexTable.Cell>
            <IndexTable.Cell>
                <Button disabled={loading || isShowProgress !== -1} onClick={(e) => {
                    stopActionDeep(e);
                    handleOptimize([[item.id], false]);
                }}>{t("Optimize")}</Button>
            </IndexTable.Cell>
        </IndexTable.Row> :
            tableType === 'history' && tabKey === 0 ? <IndexTable.Row
                id={item.id}
                key={item.id}
                selected={selectedResources.includes(item.id)}
                position={index}
                disabled={loading || Boolean(item.is_delete === 1)}
                onClick={(selectedResources.length > 0 || Boolean(item.is_delete)) ? null : () => handleProRowClick(item, index)}
            >
                <IndexTable.Cell>
                    {
                        Boolean(item.image?.length) ?
                            <Thumbnail
                                source={JSON.parse(item.image)['src']}
                                size="small"
                                alt={JSON.parse(item.image)['alt']}
                            /> : noteImg
                    }
                </IndexTable.Cell>
                <IndexTable.Cell>
                    <div className='limit_title_table'>
                        {item.title}
                    </div>
                </IndexTable.Cell>
                <IndexTable.Cell>
                    {item.optimized_images_count}
                </IndexTable.Cell>
                <IndexTable.Cell>
                    {
                        Boolean(item.is_delete === 1) ? <Badge tone={"warning"}>{t("Deleted")}</Badge> :
                            Boolean(item.opt_status === 3) ? <Badge tone={"attention"}>{t("Restored")}</Badge> :
                                Boolean(item.status) ? <Badge>{t(item.status)}</Badge> : null
                    }
                </IndexTable.Cell>
                <IndexTable.Cell>
                    {
                        Boolean(item.comp_ratio) && !Boolean(item.opt_status === 3) ? <Badge tone='success'>{(item.comp_ratio * 100).toFixed(2)}%</Badge> : null
                    }
                </IndexTable.Cell>
                {/* <IndexTable.Cell>{`${item.speed_increase}s`}</IndexTable.Cell> */}
                <IndexTable.Cell>
                    {
                        isShowAutoState ? <Tooltip content={t("Please turn off Auto Optimization switch before restoring.")}>
                            <Button disabled>{t("Restore")}</Button>
                        </Tooltip> : <Button disabled={loading || isShowProgress !== -1 || restoreProId !== -1} loading={restoreProId === item.prod_id} onClick={(e) => {
                            stopActionDeep(e);
                            optSingleRestoreImage([item.prod_id]);
                        }}>{t("Restore")}</Button>
                    }
                    {/* {
                        !Boolean(item.is_delete) ? <Button onClick={(e) => {
                            stopActionDeep(e)
                            jumpOptImgDetails(item)
                        }} variant='plain' textAlign="left">{t("Details")}</Button> : null
                    } */}
                </IndexTable.Cell>
            </IndexTable.Row> :
                (tableType === 'history' && [1, 2].includes(tabKey)) ? <IndexTable.Row
                    id={item.id}
                    key={item.id}
                    selected={selectedResources.includes(item.id)}
                    position={index}
                    disabled={loading || Boolean(item.image?.is_delete) || Boolean(item.image?.is_overdue)}
                    onClick={(selectedResources.length > 0 || !(Boolean(item.image?.is_compress) && !Boolean(item.is_delete) && !Boolean(item.image?.is_overdue) && Boolean(item.image?.is_restore !== 1))) ? null : () => handleViewImage(item)}
                >
                    <IndexTable.Cell>
                        {
                            Boolean(item.image) ?
                                <Thumbnail
                                    source={item.image?.is_delete === 1 ? item.image['after_file_path'] : item.image['src']}
                                    size="small"
                                    alt={item.image['alt']}
                                /> : noteImg
                        }
                    </IndexTable.Cell>
                    <IndexTable.Cell>
                        <div className='limit_title_table'>{item.title}</div>
                    </IndexTable.Cell>
                    <IndexTable.Cell>
                        {
                            (Boolean(item.image?.is_delete === 1)) ? <Badge tone='warning'>{t("Deleted")}</Badge> :
                                (Boolean(item.image) && (item.image.is_overdue === 1)) ? <Badge tone='warning'>{t("Expired")}</Badge> :
                                    (Boolean(item.image) && [1, 3].includes(item.image?.is_restore)) ? <Badge tone='attention'>{t("Restored")}</Badge> :
                                        Boolean(item.image) && item.opt_status === 1 ? (
                                            <div className='flex_layout badge_history'>
                                                {/* {item.image.comp_status === 4 && <Badge tone='attention'>{t("Restored")}</Badge>} */}
                                                {/* {item.image.is_delete === 1 && <Badge tone='warning'>{t("Deleted")}</Badge>} */}
                                                {item.image.is_compress === 0 && <Badge>{t("Not Compressed")}</Badge>}
                                                {item.image.is_compress === 1 && <Badge>{t("Compressed")}</Badge>}
                                                {item.image.is_to_jpg === 1 && <Badge>{t("PNG -> JPG")}</Badge>}
                                                {/* {item.image.is_edit_alt === 1 && <Badge>{t("Alt text")}</Badge>} */}
                                                {item.image.is_edit_name === 1 && <Badge>{t("File name")}</Badge>}
                                                {item.image.is_watermark === 1 && <Badge>{t("Watermark")}</Badge>}
                                            </div>
                                        ) : null

                        }
                    </IndexTable.Cell>
                    <IndexTable.Cell>
                        {
                            Boolean(item.image) ? Boolean(item.image?.file_type) ? <Badge>{(item.image.file_type).toUpperCase()}</Badge> : null : null
                        }
                    </IndexTable.Cell>
                    <IndexTable.Cell>
                        <div>
                            {
                                Boolean(item.image && item.image?.img_size) ? <Text as="p" color="critical">{t("Before")}: {changeBitInfo(item.image.img_size)}</Text> : null
                            }
                            {
                                Boolean(item.image && item.image?.comp_size) && Boolean(item.image?.is_compress) && ![1, 3].includes(item.image?.is_restore) ? <Text as="p" color="success">{t("After")}: {changeBitInfo(item.image.comp_size)}</Text> : null
                            }
                        </div>
                    </IndexTable.Cell>
                    <IndexTable.Cell>
                        {
                            Boolean(item.image?.comp_ratio) && Boolean(item.image?.is_compress) && ![1, 3].includes(item.image?.is_restore) ? <Badge tone='success'>{(item.image.comp_ratio * 100).toFixed(2)}%</Badge> : null
                        }
                    </IndexTable.Cell>
                    {/* <IndexTable.Cell>{`${item.speed_increase}s`}</IndexTable.Cell> */}
                    <IndexTable.Cell>
                        {
                            Boolean(item.image) ?
                                <div className='flex_layout'>
                                    {
                                        (Boolean(item.image?.is_compress) && !Boolean(item.is_delete) && !Boolean(item.image?.is_overdue) && Boolean(item.image?.is_restore !== 1)) ? <Button
                                            onClick={(e) => {
                                                stopActionDeep(e);
                                                openDetailCompareModal(item);
                                            }}
                                            disabled={loading || Boolean(item['restoreLoadingId'].includes(item['id']) || item['downloadLoadingId'].includes(item['id']))}
                                        >{t("View")}</Button> : null
                                    }
                                    {
                                        (((Boolean(item.image.before_file_path) && [1, 3].includes(item.image?.is_restore)) || (Boolean(item.image.after_file_path) && ![1, 3].includes(item.image?.is_restore))) && !Boolean(item.is_delete) && !Boolean(item.image?.is_overdue)) ? <Button
                                            onClick={(e) => {
                                                stopActionDeep(e);
                                                DownloadImage(item);
                                            }}
                                            disabled={loading || Boolean(item['restoreLoadingId'].includes(item['id']))}
                                            loading={Boolean(item['downloadLoadingId'].includes(item['id']))}
                                        >{t("Download")}</Button> : null
                                    }
                                    {
                                        isShowAutoState ? <Tooltip content={t("This feature is only available when the 'Optimize Images Automatically' function is disabled.")}>
                                            <Button disabled>{t("Restore")}</Button>
                                        </Tooltip> :
                                            (!Boolean(item.is_delete) && !Boolean(item.image?.is_overdue) && ![1, 3].includes(item.image?.is_restore)) ? <Button
                                                onClick={(e) => {
                                                    stopActionDeep(e);
                                                    RestoreImageData(item)
                                                }}
                                                disabled={loading || Boolean(item['downloadLoadingId'].includes(item['id']))}
                                                loading={Boolean(item['restoreLoadingId'].includes(item['id']))}
                                            >{t("Restore")}</Button> : null
                                    }
                                </div> : null
                        }
                    </IndexTable.Cell>
                </IndexTable.Row> :
                    (tableType === 'history' && tabKey === 3) ? <IndexTable.Row
                        id={item.id}
                        key={item.id}
                        selected={selectedResources.includes(item.id)}
                        position={index}
                        disabled={loading || Boolean(item.is_delete) || Boolean(item.is_overdue)}
                        onClick={(selectedResources.length > 0 || !(Boolean(item.is_compress) && !Boolean(item.is_delete) && !Boolean(item.is_overdue))) ? null : () => handleViewImage(item, index)}
                    >
                        <IndexTable.Cell>
                            {
                                Boolean(item['src']) ?
                                    <Thumbnail
                                        source={item.is_delete === 1 ? item['after_file_path'] : item['src']}
                                        size="small"
                                        alt={item['alt']}
                                    /> : noteImg
                            }
                        </IndexTable.Cell>
                        <IndexTable.Cell>
                            <div className='flex_layout badge_history'>
                                {
                                    item.is_delete === 1 ? <Badge tone='warning'>{t("Deleted")}</Badge> :
                                        item.is_overdue === 1 ? <Badge tone='warning'>{t("Expired")}</Badge> :
                                            <>
                                                {item.is_compress === 0 && <Badge>{t("Not Compressed")}</Badge>}
                                                {item.is_compress === 1 && <Badge>{t("Compressed")}</Badge>}
                                                {item.is_to_jpg === 1 && <Badge>{t("PNG -> JPG")}</Badge>}
                                                {/* {item.is_edit_alt === 1 && <Badge>{t("Alt text")}</Badge>} */}
                                                {item.is_edit_name === 1 && <Badge>{t("File name")}</Badge>}
                                                {item.is_watermark === 1 && <Badge>{t("Watermark")}</Badge>}
                                            </>
                                }
                            </div>
                        </IndexTable.Cell>
                        <IndexTable.Cell>
                            {
                                Boolean(item?.file_type) ? <Badge>{(item.file_type).toUpperCase()}</Badge> : null
                            }
                        </IndexTable.Cell>
                        <IndexTable.Cell>
                            <div>
                                {
                                    Boolean(item?.img_size) ? <Text as="p" color="critical">{t("Before")}: {changeBitInfo(item.img_size)}</Text> : null
                                }
                                {
                                    Boolean(item?.comp_size && item.is_compress !== 0) ? <Text as="p" color="success">{t("After")}: {changeBitInfo(item.comp_size)}</Text> : null
                                }
                            </div>
                        </IndexTable.Cell>
                        <IndexTable.Cell>
                            {
                                Boolean(item?.comp_ratio && item.is_compress !== 0) ? <Badge tone='success'>{(item.comp_ratio * 100).toFixed(2)}%</Badge> : null
                            }
                        </IndexTable.Cell>
                        <IndexTable.Cell>
                            <div className='flex_layout'>
                                {
                                    (Boolean(item.is_compress) && !Boolean(item.is_delete) && !Boolean(item.is_overdue)) ? <Button
                                        onClick={(e) => {
                                            stopActionDeep(e);
                                            openDetailCompareModal(item);
                                        }}
                                        disabled={loading || Boolean(item['downloadLoadingId'].includes(item['id']))}
                                    >{t("View")}</Button> : null
                                }
                                {
                                    (Boolean(item.after_file_path) && !Boolean(item.is_delete) && !Boolean(item.is_overdue)) ? <Button
                                        onClick={(e) => {
                                            stopActionDeep(e);
                                            DownloadImage(item);
                                        }}
                                        loading={Boolean(item['downloadLoadingId'].includes(item['id']))}
                                    >{t("Download")}</Button> : null
                                }
                            </div>
                        </IndexTable.Cell>
                    </IndexTable.Row> :
                        tableType === 'detail' ? <IndexTable.Row
                            id={item.id}
                            key={item.id}
                            selected={selectedResources.includes(item.id)}
                            position={index}
                            disabled={loading || Boolean(item.is_delete) || Boolean(item?.is_overdue)}
                        >
                            <IndexTable.Cell>
                                {
                                    Boolean(item['src']) ?
                                        <Thumbnail
                                            source={item.is_delete === 1 ? item?.after_file_path : item['src']}
                                            size="small"
                                            alt={""}
                                        /> : noteImg
                                }
                            </IndexTable.Cell>
                            <IndexTable.Cell>
                                <div className='flex_layout badge_history'>
                                    {item.is_delete === 1 ? <Badge tone='warning'>{t("Delete")}</Badge> :
                                        (Boolean(item) && item?.is_overdue === 1) ? <Badge tone='warning'>{t("Expired")}</Badge> :
                                            (Boolean(item) && [1, 3].includes(item?.is_restore)) ? <Badge tone='attention'>{t("Restored")}</Badge> :
                                                Boolean(item) ? <>
                                                    {item?.is_compress === 0 && <Badge>{t("Not Compressed")}</Badge>}
                                                    {item?.is_compress === 1 && <Badge>{t("Compressed")}</Badge>}
                                                    {item?.is_to_jpg === 1 && <Badge>{t("PNG -> JPG")}</Badge>}
                                                    {/* {item?.is_edit_alt === 1 && <Badge>{t("Alt text")}</Badge>} */}
                                                    {item?.is_edit_name === 1 && <Badge>{t("File name")}</Badge>}
                                                    {item?.is_watermark === 1 && <Badge>{t("Watermark")}</Badge>}
                                                </> : null
                                    }
                                </div>
                            </IndexTable.Cell>
                            <IndexTable.Cell>
                                {
                                    Boolean(item.file_type) ? <Badge>{(item.file_type).toUpperCase()}</Badge> : null
                                }
                            </IndexTable.Cell>
                            <IndexTable.Cell>
                                {
                                    Boolean(Number(item.img_size)) ? <Text as="p" color="warning">{changeBitInfo(Number(item.img_size))}</Text> : null
                                }
                            </IndexTable.Cell>
                            <IndexTable.Cell>
                                {
                                    Boolean(item?.comp_ratio && Boolean(item?.is_compress) && item?.is_compress !== 0) && ![1, 3].includes(item?.is_restore) ? <Badge tone='success'>{(item.comp_ratio * 100).toFixed(2)}%</Badge> : null
                                }
                            </IndexTable.Cell>
                            <IndexTable.Cell>
                                {
                                    Boolean(item?.comp_size && Boolean(item?.is_compress) && item?.is_compress !== 0) && ![1, 3].includes(item?.is_restore) ? <Text as="p" color="success">{changeBitInfo(item.comp_size)}</Text> : null
                                }
                            </IndexTable.Cell>
                            <IndexTable.Cell>
                                {
                                    Boolean(item) ?
                                        <div className='flex_layout'>
                                            {
                                                (item?.is_compress === 1 && !Boolean(item.is_delete) && !Boolean(item?.is_overdue) && ![1, 3].includes(item?.is_restore)) ? <Button
                                                    onClick={(e) => {
                                                        stopActionDeep(e);
                                                        openDetailCompareModal(item);
                                                    }}
                                                    disabled={loading || Boolean(item['restoreLoadingId'].includes(item['id']) || item['downloadLoadingId'].includes(item['id']))}
                                                >{t("View")}</Button> : null
                                            }
                                            {
                                                (((Boolean(item.before_file_path) && [1, 3].includes(item?.is_restore)) || (Boolean(item.after_file_path) && ![1, 3].includes(item?.is_restore))) && !Boolean(item.is_delete) && !Boolean(item?.is_overdue)) ? <Button
                                                    onClick={(e) => {
                                                        stopActionDeep(e);
                                                        DownloadImage(item);
                                                    }}
                                                    disabled={loading || Boolean(item['restoreLoadingId'].includes(item['id']))}
                                                    loading={Boolean(item['downloadLoadingId'].includes(item['id']))}
                                                >{t("Download")}</Button> : null
                                            }
                                            {
                                                isShowAutoState ? <Tooltip content={t("This feature is only available when the 'Optimize Images Automatically' function is disabled.")}>
                                                    <Button disabled>{t("Restore")}</Button>
                                                </Tooltip> :
                                                    (![1, 3].includes(item?.is_restore) && !Boolean(item.is_delete) && !Boolean(item?.is_overdue)) ? <Button
                                                        onClick={(e) => {
                                                            stopActionDeep(e);
                                                            RestoreImageData(item);
                                                        }}
                                                        disabled={loading || Boolean(item['downloadLoadingId'].includes(item['id']))}
                                                        loading={Boolean(item['restoreLoadingId'].includes(item['id']))}
                                                    >{t("Restore")}</Button> : null
                                            }
                                        </div> : null
                                }
                            </IndexTable.Cell>
                        </IndexTable.Row> : null
    });


    useEffect(() => {
        getTableItemState([selectedResources, allResourcesSelected]); // 表格选择状态

    }, [selectedResources, allResourcesSelected]);

    useEffect(() => {
        return () => {
            clearSelection();
        }
    }, [tabKey, dataList, loading])

    return (
        <div className='index_table_box' id={id}>
            <IndexTable
                loading={loading}
                resourceName={resourceName}
                itemCount={dataList.length}
                selectedItemsCount={
                    allResourcesSelected ? 'All' : selectedResources.length
                }
                onSelectionChange={handleSelectionChange}
                hasMoreItems
                // hasZebraStriping
                promotedBulkActions={promotedBulkActions}
                headings={headings}
                selectable={!(tableType === 'history' && tabKey === 3)}
            //  && !(isShowProgress === tabKey)
            >
                {TableDataList}
            </IndexTable>
        </div>
    )
};


export default withRouter(IndexTableImage);